/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useRef, useState} from 'react'
import {Input, Button, ParagraphText, Header, Radio} from '@thryvlabs/maverick'
import {AddOnsDatePickerModal} from '../add-on-components/addons-datepicker-modal'
import {toast} from 'react-toastify'
import {SEO_KEYWORD_MAX_QTY} from '../../utils/constants'
// import {toast} from 'react-toastify'

const WEBSITE_4_CODES = [
  'ent-4-website-free',
  'addon-4-website-m2m',
  'addon-4-website-sync-m2m',
  'addon-4-website-comp-m2m',
  'addon-4-website-semi',
  'addon-4-website-sync-semi',
  'sync-website-4-m2m',
  'addon-4-website-annual',
]

let options = [
  {
    label: 'No',
    value: 'No',
    default: true,
  },
  {
    label: 'Yes',
    value: 'Yes',
  },
]

function AlphaSEO({
  alphaProposalId,
  alphaDomain,
  alphaAmount,
  keywordCount,
  powerboostCount,
  handleChange,
  validateProposalId,
  diableValidateAndProposalInput,
  incrementKeyword,
  decrementKeyword,
  incrementPowerboost,
  decrementPowerboost,
  isExternalDomain,
  setIsExternalDomain,
  resetSEOData,
  listOfProducts,
  removeProduct,
  addProduct,
  setSeoDomainConfig,
  seoBillingDate,
  setSeoBillingDate = () => {},
  isSEOAlreadyOnAccount = false,
}) {
  const [isSEOOptionEnabled, setSEOOptionEnabledStatus] = useState(false)
  const [isDomainWarningVisible, setIsDomainWarningVisible] = useState(false)
  const defaultOption = options.find(x => x.default)
  const [optionValue, setOptionValue] = React.useState(defaultOption.value)
  const initializedFromExistingSeo = useRef(false)
  const keyWordIncrementDisabled =
    keywordCount >= SEO_KEYWORD_MAX_QTY ? true : false
  const keyWordDecrementDisabled = keywordCount === 0 ? true : false
  const powerboostIncrementDisabled = powerboostCount >= 3 ? true : false
  const powerboostDecrementDisabled = powerboostCount === 0 ? true : false
  const isWebsiteInTheOrder = listOfProducts?.some(({planCode}) =>
    WEBSITE_4_CODES.includes(planCode),
  )
  const showFutureBillingDateSelector = Boolean(
    optionValue === 'Yes' &&
      alphaProposalId &&
      alphaDomain &&
      isExternalDomain === 'no' &&
      !isSEOAlreadyOnAccount,
  )

  useEffect(() => {
    checkSeoOptionDisableStyle()
  }, [alphaProposalId, isExternalDomain])

  useEffect(() => {
    if (initializedFromExistingSeo.current) return
    const hasExistingSeoData = Boolean(
      alphaProposalId ||
        alphaDomain ||
        Number(keywordCount) > 0 ||
        Number(powerboostCount) > 0 ||
        seoBillingDate,
    )
    if (!hasExistingSeoData) return
    setOptionValue('Yes')
    setSeoDomainConfig(prevState => ({
      ...prevState,
      SEOSelected: true,
    }))
    initializedFromExistingSeo.current = true
  }, [
    alphaProposalId,
    alphaDomain,
    keywordCount,
    powerboostCount,
    seoBillingDate,
    setSeoDomainConfig,
  ])

  const handleDomainTypeChange = function (e) {
    console.log('conditioned added', e.target.value)
    if (e.target.value === 'yes') {
      // toast.warn(
      //   'Please Note: External site requires the client to provide website content management system & hosting access at onboarding. SEO order is subject to cancellation if access is not provided at onboarding to avoid billing client for inactive SEO campaign',
      // )
      setIsDomainWarningVisible(true)
    } else {
      setIsDomainWarningVisible(false)
    }
    if (e.target.value !== 'no') {
      setSeoBillingDate(null)
    }
    setIsExternalDomain(e.target.value)
  }

  const checkSeoOptionDisableStyle = () => {
    if (
      alphaProposalId &&
      alphaProposalId.length &&
      isExternalDomain !== null
    ) {
      setSEOOptionEnabledStatus(true)
    } else {
      setSEOOptionEnabledStatus(false)
    }
  }

  const handleOnChange = e => {
    setOptionValue(e.target.value)
    setSeoDomainConfig(prevState => ({
      ...prevState,
      SEOSelected: e.target.value === 'Yes' ? true : false,
    }))
    if (e.target.value === 'Yes') {
      let oldSeoPlan = listOfProducts.find(item =>
        ['addon-4-seombg-m2m', 'addon-4-seo-m2m'].includes(item.planCode),
      )
      if (oldSeoPlan) {
        console.log({oldSeoPlan})
      }
    } else {
      resetSEOData()
      let newSEO = listOfProducts.filter(item =>
        [
          'addon-4-seobase-m2m',
          'addon-4-seokey-m2m',
          'addon-4-seopb-m2m',
        ].includes(item.planCode),
      )
      if (newSEO.length > 0) {
        removeProduct([...newSEO.map(item => item.id)])
      }
    }
  }
  const disableStyle = {
    pointerEvents: 'none',
    opacity: 0.5,
  }

  return (
    <div className="ml-3" style={{borderBottom: '1px solid #eee'}}>
      <div
        className="row ml-0"
        style={{marginTop: '1rem', alignItems: 'center'}}
      >
        <div className="col-lg-6">
          <div className="float-left d-flex" style={{position: 'relative'}}>
            <Header className="mr-2" fontWeight="normal" variant="h4">
              {'AEO & SEO'}
              <p
                style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  lineHeight: '20px',
                  color: 'rgb(163, 165, 167)',
                  fontStyle: 'normal',
                  fontFamily: 'open-sans',
                }}
              >{`$${alphaAmount || 0}`}</p>
            </Header>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="float-right" style={{position: 'relative'}}>
            <div className="row">
              {options?.map((option, key) => (
                <Radio
                  key={key}
                  className="ml-6"
                  hasLabel
                  id={`AEO & SEO`}
                  name={`AEO & SEO`}
                  value={option.value}
                  label={option.label}
                  toggled={optionValue === option.value}
                  handleOnChange={handleOnChange}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div
        className="d-flex flex-column ml-3"
        style={
          optionValue !== 'Yes'
            ? {...disableStyle, rowGap: '10px'}
            : {rowGap: '10px'}
        }
      >
        <div className="d-flex">
          <div className="d-flex" style={{columnGap: '20px'}}>
            <div>
              <ParagraphText variant="reg" className="text-left">
                Proposal ID *
              </ParagraphText>
              <div style={{width: '100%', display: 'flex', gap: '10px'}}>
                <Input
                  required
                  type="text"
                  placeholder="Enter Proposal ID"
                  name="proposalId"
                  withLabel
                  labelType="static"
                  variant="input-isolated"
                  onChange={handleChange}
                  value={optionValue === 'Yes' ? alphaProposalId : ''}
                  disabled={diableValidateAndProposalInput}
                />
                <Button
                  variant="primary"
                  disabled={diableValidateAndProposalInput}
                  onClick={validateProposalId}
                >
                  Validate
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="w-50" style={{marginTop: '10px'}}>
          <ParagraphText variant="reg" className="text-left">
            Domain
          </ParagraphText>
          <Input
            aria-label="Domain"
            required
            type="text"
            placeholder=""
            name="domain"
            withLabel
            labelType="static"
            variant="input-isolated"
            value={alphaDomain}
            disabled={true}
          />
        </div>
        <div style={{marginTop: '10px'}}>
          <ParagraphText variant="reg" className="text-left">
            {'External Domain? *'}
          </ParagraphText>
          <div className="d-flex gap-3">
            <Radio
              hasLabel
              id="yes"
              name="isExternalDomain"
              value="yes"
              label="Yes"
              toggled={isExternalDomain === 'yes'}
              handleOnChange={handleDomainTypeChange}
            />
            <Radio
              hasLabel
              id="no"
              name="isExternalDomain"
              value="no"
              label="No"
              toggled={isExternalDomain === 'no'}
              handleOnChange={handleDomainTypeChange}
            />
          </div>
          {isDomainWarningVisible && (
            <div>
              <ParagraphText variant="reg" className="text-left">
                <strong>Please Note:</strong>
                {
                  ' External site requires the client to provide website content management system & hosting access at onboarding. SEO order is subject to cancellation if access is not provided at onboarding to avoid billing client for inactive SEO campaign'
                }
              </ParagraphText>
            </div>
          )}
        </div>
        {showFutureBillingDateSelector && (
          <div style={{marginTop: '10px'}}>
            <ParagraphText variant="reg" className="m-0">
              Do you want to start the billing on a different date?
            </ParagraphText>
            <AddOnsDatePickerModal
              setSelectedDate={setSeoBillingDate}
              billingDate={seoBillingDate}
              maxDate={30}
              useOverrideUseEffect
              overrideOnClick={
                isWebsiteInTheOrder
                  ? undefined
                  : () => {
                      toast.warn(
                        'Thryv Website must be included on the order to enable Future Start Date',
                      )
                    }
              }
            />
          </div>
        )}
        <div className="w-50" style={!isSEOOptionEnabled ? disableStyle : {}}>
          <div
            key={'keyword'}
            className="d-flex align-items-center  justify-content-between"
          >
            <div>
              <ParagraphText
                variant="reg"
                className="text-left"
                style={{marginTop: '24px'}}
              >
                {'Keywords:'}
              </ParagraphText>
            </div>
            <div className="d-flex align-items-center ">
              <Button
                disabled={keyWordDecrementDisabled}
                variant="primary"
                buttonType="outlined"
                onClick={decrementKeyword}
                className="fontSizeUpdate"
              >
                -
              </Button>
              &nbsp;
              {Number(keywordCount)}
              &nbsp;
              <Button
                disabled={keyWordIncrementDisabled}
                variant="primary"
                buttonType="outlined"
                onClick={incrementKeyword}
                className="fontSizeUpdate"
              >
                +
              </Button>
            </div>
          </div>

          <div
            key={'Powerboost'}
            className="d-flex align-items-center justify-content-between"
          >
            <div>
              <ParagraphText
                variant="reg"
                className="text-left"
                style={{marginTop: '24px'}}
              >
                {'AEO & SEO PowerBoost:'}
              </ParagraphText>
            </div>
            <div className="d-flex align-items-center ">
              <Button
                disabled={powerboostDecrementDisabled}
                variant="primary"
                buttonType="outlined"
                onClick={decrementPowerboost}
                className="fontSizeUpdate"
              >
                -
              </Button>
              &nbsp;
              {Number(powerboostCount)}
              &nbsp;
              <Button
                disabled={powerboostIncrementDisabled}
                variant="primary"
                buttonType="outlined"
                onClick={incrementPowerboost}
                className="fontSizeUpdate"
              >
                +
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {AlphaSEO}
